export abstract class WorkspaceVersions {

    static readonly routingVersion = 1;
    static readonly mapVersion = 1;
    static readonly tableVersion = 2;
    static readonly filtersVersion = 1;
}
